export const ClientBookingLocationsPage = {
  en: {
    'Select location': 'Select location',
  },
  uk: {
    'Select location': 'Оберіть локацію',
  },
};
